// @flow
import React, {PureComponent} from "react";
import SVGMarker from "./SVGMarker";
import vanIconPath from "../../../Assets/commonImages/car_marker_icon.svg";
import {connect} from "react-redux";
import {SVGToBase64Url, rotateSVGArray} from "../../../Utils/SVGUtils";
import type {SVGMarkerProps, SVGMarkerState} from "./SVGMarker";
import Markers from "../../../Store/Views/markers";
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";

const derivedStateFromProps = (props: SVGMarkerProps, state: SVGMarkerState): SVGMarkerState => {
    if (state.iconSVG) {
        rotateSVGArray(state.iconSVG.children, props.bearing, 100, 100);
        return {
            iconURL: SVGToBase64Url(state.iconSVG),
            iconSVG: state.iconSVG,
        };
    }
    return state;
};

type ConnectedProps = {
    vanLocationLat: number,
    vanLocationLng: number,
    vanLocationBearing: number,
    showVanMarker: boolean,
}

class VanMarker extends PureComponent<ConnectedProps> {
    render() {
        return (<SVGMarker
            key={"vanMarkerSVG"}
            iconPath={vanIconPath}
            visible={this.props.showVanMarker}
            lat={this.props.vanLocationLat}
            lng={this.props.vanLocationLng}
            bearing={this.props.vanLocationBearing}
            icon={{
                scaledSize: new window.google.maps.Size(50, 50),
                anchor: new window.google.maps.Point(25, 25),
            }}
            derivedStateFromProps={derivedStateFromProps}
            useMotion={true}

        />);
    }

};

const mapStateToProps = (state, props) => {
    return {
        showVanMarker: Markers.shouldShowVanMarker(state),
        vanLocationLat: CurrentRideSelectors.getVanLocationLat(state),
        vanLocationLng: CurrentRideSelectors.getVanLocationLng(state),
        vanLocationBearing: CurrentRideSelectors.getVanLocationBearing(state),
    };
};

export default connect(mapStateToProps)(VanMarker);



// WEBPACK FOOTER //
// ./src/Components/Map/Markers/VanMarker.js